'use strict';

let codes = Object.freeze({
    ACHIEVEMENT_NOT_FOUND : 'depot.achievementNotFound',
    APP_ALREADY_EXISTS    : 'depot.appAlreadyExists',
    APP_NOT_FOUND         : 'depot.appNotFound',
    CLIENT_ALREADY_EXISTS : 'depot.clientAlreadyExists',
    CLIENT_NOT_FOUND      : 'depot.clientNotFound',
    SERVICE_NOT_FOUND     : 'depot.serviceNotFound',
    SERVICE_ALREADY_EXISTS: 'depot.serviceAlreadyExists',
    SCOPE_NOT_FOUND       : 'depot.scopeNotFound'
});

module.exports = codes;
